export default "__VITE_ASSET__BneWb9a8__"